import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusBaseErrorFragmentDoc } from './BaseError.generated'
import * as Types from './purchasePlus_graphql'

export const UpdateUserDocument = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        fullName
        email
        telephone
        staffCode
        autoSendPurchaseOrder
        createdAt
        tandcagreedon
        confirmedAt
        currentSignInAt
        position
        status
        enableMultiFactorAuthentication
        defaultOrganisation {
          id
          name
        }
        applicationPreferences {
          viewPreference
          allowInvoiceEditing
          expertMode
          defaultLanguage
          shoppingPreference
        }
      }
      errors {
        ...PurchasePlusBaseError
      }
    }
  }
  ${PurchasePlusBaseErrorFragmentDoc}
` as unknown as DocumentNode<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>
